// @flow
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  max-width: 590px;
  margin: auto;
`;

const Card = styled.div`
  padding: 20px 0px;
  margin-bottom: 20px;
`;

const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
`;

const Job = styled.span`
  margin: 0px;
  text-align: left;
`;

const AuthorPhoto = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 10px;
`;

const Name = styled.div`
  margin-bottom: 5px;
  color: ${({ theme }) => theme.palette.hague};
  font-weight: 500;
`;

type Props = {
  author: PrismicAuthor,
};

const Author = ({ author }: Props) => (
  <Wrapper>
    <Card>
      <AuthorInfo>
        <AuthorPhoto src={author.data.photo.url} />
        <div>
          <Name data-test="author-name">{author.data.name}</Name>
          <Job>{author.data.job}</Job>
        </div>
      </AuthorInfo>
    </Card>
  </Wrapper>
);

export { Author };
